<template>
  <form-base
      title="Update Provider"
      :cancel="isForAdmin ? 'AdminProviderList' : 'OrganizationDetail'"
      :error="form.errors.get('NOFIELD')"
      @submit="handleSubmit"
    >
      <template v-slot:fields>
        <div class="block">
          <form-input :form="form" label="Provider Name" field-name="name" />
        </div>

        <div class="block">
          <form-input :form="form" label="Provider ID (NPI)" field-name="npi" />
        </div>

        <div class="block">
          <form-input :form="form" label="Tax ID" field-name="tax_id" />
        </div>

        <div class="block">
          <form-switch :form="form" label="Is Active" field-name="is_active" />
        </div>
      </template>
    </form-base>
</template>

<script>
import Form from '../utils/form';
import FormBase from '../components/FormBase.vue';
import FormInput from '../components/FormInput.vue';
import FormSwitch from '../components/FormSwitch.vue';

export default {
  name: 'AdminProviderUpdate',
  components: { FormBase, FormInput, FormSwitch },
  data() {
    return {
      loading: true,
      provider: null,
      form: new Form({
        name: '',
        npi: '',
        tax_id: '',
      }),
    };
  },
   props: {
    Provider: Object,
    isForAdmin: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.setData(this.Provider);
  },
  mounted() {
  window.scrollTo(0, 0);
},

  methods: {
    setData(provider) {
      this.provider = provider;
      this.form = new Form({
        name: provider.name,
        npi: provider.npi,
        tax_id: provider.tax_id,
        is_active: provider.is_active,
      });
      this.loading = false;
    },
    handleSubmit() {
      const url = this.isForAdmin ? `/admin/providers/${this.$route.params.id}` : `/providers/${this.$route.params.id}`;
      this.loading = true;
      this.form
        .put(url)
        .then(() => {
          let msg = `${this.form.name} was updated successfully.`;
          this.$buefy.toast.open({ message: msg, type: 'is-success' });
          const routeTo = this.isForAdmin ? 'AdminProviderList' : 'OrganizationDetail';
          this.$router.push({ name: routeTo });
        })
        .catch(() => {
          if (!this.form.errors.any()) {
            this.form.errors.setGenericError();
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
